/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DailyLogQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type DailyLogQuery = {
  __typename?: 'Query';
  needToAnswerDailyLog: boolean;
  dailyLogDate: string;
  questions: Array<{
    __typename?: 'Question';
    _id: string;
    title: string;
    description?: string | null;
    type: Types.QuestionType;
    inputMethod: Types.InputMethod;
    minValue?: number | null;
    maxValue?: number | null;
    minLabel?: string | null;
    maxLabel?: string | null;
    dropdownOptions?: Array<{ __typename?: 'DropdownOption'; option: string }> | null;
  }>;
  dailyLogActivities: Array<{ __typename?: 'ActivityLog'; activityId: string; day: string; period: string }>;
};

export type CreateDailyLogMutationVariables = Types.Exact<{
  input: Types.DailyLogInput;
}>;

export type CreateDailyLogMutation = {
  __typename?: 'Mutation';
  createDailyLog: {
    __typename?: 'DailyLog';
    _id: string;
    date: any;
    activities: Array<{ __typename?: 'DailyLogActivity'; activityID: string; status: Types.ActivityStatus }>;
    questions: Array<{ __typename?: 'DailyLogQuestion'; questionID: string; answer: string }>;
  };
};

export const DailyLogDocument = gql`
  query dailyLog($offset: Int!) {
    needToAnswerDailyLog(offset: $offset)
    dailyLogDate(offset: $offset)
    questions(type: DailyLog) {
      _id
      title
      description
      type
      inputMethod
      dropdownOptions {
        option
      }
      minValue
      maxValue
      minLabel
      maxLabel
    }
    dailyLogActivities(offset: $offset) {
      activityId
      day
      period
    }
  }
`;

/**
 * __useDailyLogQuery__
 *
 * To run a query within a React component, call `useDailyLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyLogQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useDailyLogQuery(baseOptions: Apollo.QueryHookOptions<DailyLogQuery, DailyLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DailyLogQuery, DailyLogQueryVariables>(DailyLogDocument, options);
}
export function useDailyLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyLogQuery, DailyLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DailyLogQuery, DailyLogQueryVariables>(DailyLogDocument, options);
}
export type DailyLogQueryHookResult = ReturnType<typeof useDailyLogQuery>;
export type DailyLogLazyQueryHookResult = ReturnType<typeof useDailyLogLazyQuery>;
export type DailyLogQueryResult = Apollo.QueryResult<DailyLogQuery, DailyLogQueryVariables>;
export const CreateDailyLogDocument = gql`
  mutation createDailyLog($input: DailyLogInput!) {
    createDailyLog(input: $input) {
      _id
      date
      activities {
        activityID
        status
      }
      questions {
        questionID
        answer
      }
    }
  }
`;
export type CreateDailyLogMutationFn = Apollo.MutationFunction<CreateDailyLogMutation, CreateDailyLogMutationVariables>;

/**
 * __useCreateDailyLogMutation__
 *
 * To run a mutation, you first call `useCreateDailyLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyLogMutation, { data, loading, error }] = useCreateDailyLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyLogMutation, CreateDailyLogMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDailyLogMutation, CreateDailyLogMutationVariables>(CreateDailyLogDocument, options);
}
export type CreateDailyLogMutationHookResult = ReturnType<typeof useCreateDailyLogMutation>;
export type CreateDailyLogMutationResult = Apollo.MutationResult<CreateDailyLogMutation>;
export type CreateDailyLogMutationOptions = Apollo.BaseMutationOptions<CreateDailyLogMutation, CreateDailyLogMutationVariables>;
